/* eslint-disable react/display-name */
/* eslint-disable react/jsx-key */
import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Controller } from 'react-hook-form';

export default function InputSwitchControl({
    title,
    endAdornment = null,
    control,
    disabled = false,
    dark = false,
    name,
    defaultValue,
    required = false,
    style = {},
    switchProps = {},
    ...props
}) {
    const theme = useTheme();

    return (
        <Controller
            control={control}
            defaultValue={defaultValue}
            name={name}
            rules={{
                required,
            }}
            render={({ field: { value, onChange } }) => {
                const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                    onChange(checked);
                    props?.onChange?.(checked);
                };

                if (props.viewOnly) {
                    return (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                gap: 1,
                                ...style,
                                ...props.containerStyle,
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: theme.palette.text.secondary,
                                    fontFamily: 'Lemon-Milk-Pro-Regular',
                                    fontWeight: 'normal',
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: value ? theme.palette.successGreen.main : theme.palette.text.disabled,
                                    fontWeight: 500,
                                }}
                            >
                                {value ? 'Activé' : 'Désactivé'}
                            </Typography>
                            {endAdornment}
                        </Box>
                    );
                }

                return (
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            ...style,
                            ...props.containerStyle,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, mr: '15px', mb: '5px', gap: 1 }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: disabled ? theme.palette.action.disabled : theme.palette.text.primary,
                                    fontFamily: 'Lemon-Milk-Pro-Regular',
                                    fontSize: 14,
                                    lineHeight: '20px',
                                }}
                            >
                                {title}
                            </Typography>
                            {endAdornment}
                        </Box>
                        <Switch
                            checked={Boolean(value)}
                            disabled={disabled}
                            onChange={handleChange}
                            color="primary"
                            sx={{
                                transform: 'scale(0.8)',
                                opacity: disabled ? 0.5 : 1,
                            }}
                            {...switchProps}
                        />
                    </Box>
                );
            }}
        />
    );
}
